import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { serializeFilters } from '@user/components/Filters'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { useSaveGuestUserOppsFilterSet } from '@user/store/guestUser'
import { IOpportunity, OpportunityFilterSet } from '@user/store/opportunity'

export const useSaveOppsFilters = () => {
  const dispatch = useAppDispatch()
  const saveFilters = useSaveGuestUserOppsFilterSet()
  const prefs = useSelector(selectAllFilterPreferences)

  const leadPref = useMemo(
    () => prefs.find((p) => p.type === 'guestUserDashboardOpportunities'),
    [prefs],
  )

  return useCallback(
    (model: OpportunityFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: leadPref?.id,
          type: 'guestUserDashboardOpportunities',
          name: 'guestUserDashboardOpportunities filters',
          filter: serializeFilters<IOpportunity, OpportunityFilterSet>(model),
        }),
      )

      saveFilters(model)
    },
    [dispatch, leadPref?.id, saveFilters],
  )
}
